import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular'
import { DirectivesModule } from '../directives/directives.module';
import { MultiFileUploadComponent } from './multi-file-upload/multi-file-upload';
import { FileUploadModule } from 'ng2-file-upload';
import { MatNativeDateModule, MatDatepickerModule,MatFormFieldModule,MatInputModule, MatSelectModule, MatOptionModule, MatExpansionModule, MatTabsModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatTableModule, MatPaginatorModule, MatSortModule, MatDialogModule, MatGridListModule, MatSlideToggleModule, MatCardModule, MatAutocompleteModule } from '@angular/material';

import { PatientTasksComponent } from './patient-tasks/patient-tasks';
import { PatientSummaryComponent } from './patient-summary/patient-summary';
import { AdherenceCallDialogComponent } from './adherence-call-dialog/adherence-call-dialog';
import { ChartDialogComponent } from './chart-dialog/chart-dialog';
import { StatusDialogComponent } from './status-dialog/status-dialog';
import { PatientAdherenceCallComponent } from './patient-adherence-call/patient-adherence-call';
import { MultiFileUploadComponentSecure } from './multi-file-upload-secure/multi-file-upload-secure';
import { PatientChartComponent } from './patient-chart/patient-chart';
import { PatientClinicalComponent } from './patient-clinical/patient-clinical';
import { PatientOrderComponent } from './patient-order/patient-order';
import { PatientReimbursementComponent } from './patient-reimbursement/patient-reimbursement';
import { PatientDocumentComponent } from './patient-document/patient-document';
import { PatientDispensingComponent } from './patient-dispensing/patient-dispensing';
import { DocumentProcessDialogComponent } from './document-process-dialog/document-process-dialog';
import { SendFaxDialogComponent } from './send-fax-dialog/send-fax-dialog';
import { DocumentUploadComponent } from './document-upload/document-upload';
import { PatientPhysicianComponent } from './patient-physician/patient-physician';
import { PatientAdverseEventComponent } from './patient-adverse-event/patient-adverse-event';
import { StatusTherapyDialogComponent } from './status-therapy-dialog/status-therapy-dialog';

@NgModule({
	declarations: [
	MultiFileUploadComponent,
	PatientTasksComponent,
	PatientSummaryComponent,
	AdherenceCallDialogComponent,
	ChartDialogComponent,
	StatusDialogComponent,
	StatusTherapyDialogComponent,
	PatientAdherenceCallComponent,
	MultiFileUploadComponentSecure,
	PatientChartComponent,
	PatientClinicalComponent,
    PatientOrderComponent,
    PatientReimbursementComponent,
    PatientDocumentComponent,
    PatientDispensingComponent,
    DocumentProcessDialogComponent,
    SendFaxDialogComponent,
    DocumentUploadComponent,
    PatientPhysicianComponent,
    PatientAdverseEventComponent,
	],
	imports: [
	IonicModule, 
	DirectivesModule, 
	FileUploadModule, 
	MatNativeDateModule, 
	MatDatepickerModule,
	MatFormFieldModule,
	MatInputModule,
	MatSelectModule,
	MatOptionModule,
	MatExpansionModule,
	MatTabsModule,
	MatIconModule,
	MatButtonModule,
	MatCheckboxModule,
	MatRadioModule,
	MatTableModule,
	MatPaginatorModule, MatSortModule, MatDialogModule, MatGridListModule, MatSlideToggleModule, MatCardModule, MatAutocompleteModule
	],
	exports: [
	MultiFileUploadComponent,
	PatientTasksComponent,
	PatientSummaryComponent,
	ChartDialogComponent,
	StatusDialogComponent,
	StatusTherapyDialogComponent,
	PatientAdherenceCallComponent,
	MultiFileUploadComponentSecure,
	PatientChartComponent,
	PatientClinicalComponent,
	PatientOrderComponent,
	PatientReimbursementComponent,
	PatientDocumentComponent,
    PatientDispensingComponent,
    DocumentProcessDialogComponent,
    SendFaxDialogComponent,
    DocumentUploadComponent,
    PatientPhysicianComponent,
    PatientAdverseEventComponent,
	]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts